import React, { useContext, useEffect, useState } from 'react';
import { GraphRenderer } from './components/charts/GraphRenderer';
import { OrbUserContext } from './components/OrbUserContext';
import { CrLoadingOverlay } from './components/cr/CrLoadingOverlay';

interface IHomeTilesProps {
    menuData: any[];
}

export const HomeTiles = ({ menuData }: IHomeTilesProps): React.ReactElement => {
    const imagesRoot: string = process.env.REACT_APP_ZedXImagesRoot!;
    const { userContext } = useContext(OrbUserContext);

    const [filteredApps, setFilteredApps] = useState<any[] | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        if (userContext.UserId > 0) {
            setFilteredApps(userContext.UserType === 'Student'
                ? menuData.filter(x => x.ID === 13)  // Only Study Planner
                : menuData.filter(x => x.ID !== 13)  // Exclude Study Planner
            );
            setIsLoading(false);
        }        
    }, [userContext, menuData, userContext?.UserType]);

    return (
        <div>
            <div style={{ marginTop: '10px' }} className="apps-home">
                <CrLoadingOverlay isLoading={isLoading} opaque={true} />
                {filteredApps?.map((m, index) => (
                    <div key={`homeTile_${index}`} className="rectangle">
                        <a href={`#${m?.AppLink}/welcome`}>
                            <img src={`${imagesRoot}${m?.AppImage}?v=2`} alt={m?.AppName} />
                            <div className="rectangle-title">{m?.AppName}</div>
                        </a>
                    </div>
                ))}
            </div>
            <div style={{ marginTop: '30px', paddingLeft: '10px', paddingRight: '10px' }}>
                {/* {filteredApps.length > 0 && <GraphRenderer menuData={filteredApps} graphShortname={'test1'} />} */}
            </div>
        </div>
    );
};

export default HomeTiles;
